<template>
    <basic-card>
        <data-table
          :data="operationDefinitions"
          :configuration="operationDefinitionsTableConfig"
          component-id="operation-definitions-list-widget"
        />

    </basic-card>
</template>

<script>
import BasicCard from "../../layout/BasicCard";
import OperationDefinitionsListCard from "@/cards/OperationDefinitionsListCard";
import DataTable from "@/components/table/DataTable";
import { mapGetters } from "vuex";

export default {
    name: "OperationDefinitionsListWidget",

    components: {DataTable, OperationDefinitionsListCard, BasicCard},
    data() {
        return {
            operationDefinitionsTableConfig: {
                columns: [

                    {
                        caption: this.$t('name'),
                        datum: d => d.name
                    },
                    {
                        caption: this.$t('code'),
                        datum: d => d.code
                    }
                ],
            }
        }
    },
    computed: {
        ...mapGetters({
            operationDefinitions: "operationDefinitions/operationDefinitions"
        })
    },
}
</script>

<style scoped>

</style>